module.exports = __webpack_public_path__ + "static/media/w (40).c2f2e9e9.jpg";